import { render, staticRenderFns } from "./ErrorGeneric.vue?vue&type=template&id=63908514"
import script from "./ErrorGeneric.vue?vue&type=script&lang=js"
export * from "./ErrorGeneric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports